import { UPDATE_USER } from "../actionTypes";

const initialState = {};

export default function index(state = initialState, action) {
  switch (action.type) {
    case UPDATE_USER: {
      return {
        ...state,
        ...action.payload,
      };
    }

    default:
      return state;
  }
}
